import SubLanding from "@/components/SubLanding";
export default function SelfReflectionApp() { return <SubLanding slug="self-reflection-app" />; }
